(() => {
  document.documentElement.classList.remove('no-js');
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const fine = matchMedia('(hover:hover) and (pointer:fine)').matches;
  const calm = matchMedia('(prefers-reduced-motion: reduce)').matches; // solo suaviza parallax/inclinación
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));

  $$('[data-split]').forEach(el => {
    el.innerHTML = el.textContent.trim().split(/\s+/).map((w, i) =>
      `<span class="w"><span style="transition-delay:${i * 0.06}s">${w}</span></span>`).join(' ');
    el.classList.add('lt-split');
  });

  const io = new IntersectionObserver(es => es.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
  }), { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
  $$('[data-reveal], .lt-split').forEach(el => io.observe(el));

  const cio = new IntersectionObserver(es => es.forEach(e => {
    if (!e.isIntersecting) return;
    const el = e.target, end = parseFloat(el.dataset.count) || 0, suf = el.dataset.suffix || '', t0 = performance.now();
    const tick = t => {
      const k = clamp((t - t0) / 1500, 0, 1);
      el.textContent = Math.round(end * (1 - Math.pow(1 - k, 4))) + suf;
      if (k < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick); cio.unobserve(el);
  }), { threshold: 0.5 });
  $$('[data-count]').forEach(el => cio.observe(el));

  // solo calculamos lo que está en pantalla
  const live = new Set();
  const vio = new IntersectionObserver(es => es.forEach(e => e.isIntersecting ? live.add(e.target) : live.delete(e.target)), { rootMargin: '20% 0px' });
  const bar = $('.lt-progress span'), header = $('.lt-header');
  const stripes = $$('.lt-stripes'), steps = $$('.lt-steps__list'), marquees = $$('[data-marquee]');
  const parallax = (fine && !calm) ? $$('[data-speed]') : [];
  [...stripes, ...steps, ...parallax, ...marquees].forEach(el => vio.observe(el));

  const progressOf = el => {
    const r = el.getBoundingClientRect(), total = el.offsetHeight - innerHeight;
    return clamp(-r.top / (total || 1), 0, 1);
  };
  let docH = 1;
  const measure = () => { docH = Math.max(1, document.documentElement.scrollHeight - innerHeight); };
  measure(); addEventListener('resize', measure); addEventListener('load', measure);

  const onScroll = () => {
    const y = scrollY;
    if (bar) bar.style.transform = `scaleX(${y / docH})`;
    if (header) header.classList.toggle('is-scrolled', y > 20);
    stripes.forEach(s => {
      if (!live.has(s)) return;
      const p = progressOf(s);
      s.style.setProperty('--ip', p.toFixed(3));
      $$('.lt-stripe', s).forEach((st, i) => {
        const l = clamp((p - 0.04 - i * 0.15) / 0.36, 0, 1);
        st.style.setProperty('--p', (1 - Math.pow(1 - l, 3)).toFixed(3));
      });
    });
    steps.forEach(list => {
      if (!live.has(list)) return;
      const fg = $('.fg', list); if (!fg) return;
      const r = list.getBoundingClientRect();
      fg.style.strokeDashoffset = 1 - clamp((innerHeight * 0.6 - r.top) / r.height, 0, 1);
    });
    parallax.forEach(el => {
      if (!live.has(el)) return;
      const r = el.getBoundingClientRect();
      el.style.transform = `translate3d(0,${(r.top + r.height / 2 - innerHeight / 2) * parseFloat(el.dataset.speed)}px,0)`;
    });
  };
  let ticking = false;
  addEventListener('scroll', () => {
    if (!ticking) { ticking = true; requestAnimationFrame(() => { onScroll(); ticking = false; }); }
  }, { passive: true });
  onScroll();

  // cintas: se mueven solas y aceleran con el scroll; se paran fuera de pantalla
  let py = scrollY, vel = 0, dir = 1, off = 0, running = false;
  const halves = new Map();
  const halfOf = m => { if (!halves.has(m)) halves.set(m, m.scrollWidth / 2 || 1); return halves.get(m); };
  addEventListener('resize', () => halves.clear());
  const loop = () => {
    const vis = marquees.filter(m => live.has(m));
    if (!vis.length || document.hidden) { running = false; return; }
    const d = scrollY - py; py = scrollY;
    if (d) dir = d > 0 ? 1 : -1;
    vel = vel * 0.9 + Math.min(Math.abs(d), 60) * 0.2;
    off += (1 + vel) * dir;
    vis.forEach(m => {
      const half = halfOf(m), sign = m.dataset.marquee === 'rev' ? 1 : -1;
      m.style.transform = `translate3d(${-((((off * sign) % half) + half) % half)}px,0,0)`;
    });
    requestAnimationFrame(loop);
  };
  const kick = () => { if (!running && marquees.length) { running = true; requestAnimationFrame(loop); } };
  new IntersectionObserver(es => { es.forEach(e => e.isIntersecting ? live.add(e.target) : live.delete(e.target)); kick(); }).observe(document.body);
  marquees.forEach(m => new IntersectionObserver(([e]) => { e.isIntersecting ? live.add(m) : live.delete(m); kick(); }).observe(m));
  document.addEventListener('visibilitychange', kick);

  // cursor + minijuego (en móvil funciona con toques)
  const cursor = $('.lt-cursor'), fx = $('.lt-fx'), scoreEl = $('[data-score]'), hud = $('.lt-hud');
  let score = 0;
  try { score = parseInt(sessionStorage.getItem('lt-score') || '0', 10) || 0; } catch (e) {}
  const render = () => { if (scoreEl) scoreEl.textContent = String(score).padStart(4, '0'); };
  render();
  const addScore = n => {
    score += n; render();
    try { sessionStorage.setItem('lt-score', score); } catch (e) {}
    if (hud) { hud.classList.remove('is-bump'); void hud.offsetWidth; hud.classList.add('is-bump'); }
  };
  if (fine && cursor) {
    let cx = innerWidth / 2, cy = innerHeight / 2, tx = cx, ty = cy, moving = false;
    const follow = () => {
      cx += (tx - cx) * 0.35; cy += (ty - cy) * 0.35;
      cursor.style.transform = `translate3d(${cx}px,${cy}px,0)`;
      if (Math.abs(tx - cx) + Math.abs(ty - cy) > 0.5) requestAnimationFrame(follow); else moving = false;
    };
    addEventListener('mousemove', e => { tx = e.clientX; ty = e.clientY; if (!moving) { moving = true; requestAnimationFrame(follow); } }, { passive: true });
    document.addEventListener('mouseover', e => cursor.classList.toggle('is-hover', !!e.target.closest('a,button,summary,input,label')));
  }
  const sparks = (x, y, n = fine ? 12 : 8) => {
    if (!fx) return;
    for (let i = 0; i < n; i++) {
      const s = document.createElement('i'), a = Math.random() * Math.PI * 2, d = 40 + Math.random() * 70;
      s.className = 'lt-spark';
      s.style.cssText = `left:${x}px;top:${y}px;--dx:${Math.cos(a) * d}px;--dy:${Math.sin(a) * d}px;--rot:${Math.random() * 360}deg;background:${i % 2 ? 'var(--lime)' : 'var(--violet-2)'}`;
      fx.appendChild(s); setTimeout(() => s.remove(), 850);
    }
  };
  const popText = (x, y, txt, violet) => {
    if (!fx) return;
    const p = document.createElement('span');
    p.className = 'lt-pop' + (violet ? ' is-violet' : '');
    p.style.left = x + 'px'; p.style.top = y + 'px'; p.textContent = txt;
    fx.appendChild(p); setTimeout(() => p.remove(), 950);
  };
  const shoot = (x, y) => {
    const ox = innerWidth * (x < innerWidth / 2 ? 0.04 : 0.96), oy = innerHeight + 10, dx = x - ox, dy = y - oy;
    const beam = document.createElement('i'), burst = document.createElement('i');
    beam.className = 'lt-beam';
    beam.style.cssText = `left:${ox}px;top:${oy}px;width:${Math.hypot(dx, dy)}px;transform:rotate(${Math.atan2(dy, dx)}rad)`;
    burst.className = 'lt-burst'; burst.style.left = x + 'px'; burst.style.top = y + 'px';
    fx.append(beam, burst);
    setTimeout(() => { beam.remove(); burst.remove(); }, 520);
  };
  const words = ['HEADSHOT!', 'ZAP!', 'COMBO x2', 'BOOM', 'ON FIRE', 'IMPACTO'];
  let unlocked = score >= 500;
  document.addEventListener('click', e => {
    if (!fx) return;
    const target = e.target.closest('.lt-target');
    if (!target && e.target.closest('a,button,input,select,textarea,summary,label,form,[data-track]')) return;
    shoot(e.clientX, e.clientY);
    if (target) {
      if (target.classList.contains('is-hit')) return;
      target.classList.add('is-hit');
      sparks(e.clientX, e.clientY);
      popText(e.clientX, e.clientY - 20, words[Math.floor(Math.random() * words.length)]);
      if (navigator.vibrate) try { navigator.vibrate(30); } catch (err) {}
      addScore(100);
      setTimeout(() => {
        target.style.left = (6 + Math.random() * 76) + '%'; target.style.top = (6 + Math.random() * 76) + '%';
        target.classList.remove('is-hit');
      }, 900);
      if (score >= 500 && !unlocked) {
        unlocked = true;
        setTimeout(() => popText(innerWidth / 2, innerHeight / 2, '¡NIVEL PRO DESBLOQUEADO!', true), 250);
        for (let k = 0; k < 4; k++) setTimeout(() => sparks(Math.random() * innerWidth, Math.random() * innerHeight * 0.7), k * 110);
      }
    } else { addScore(10); popText(e.clientX, e.clientY - 16, '+10'); }
  });

  const stage = $('[data-tilt]');
  if (stage && fine && !calm) {
    const card = $('.lt-hero__card', stage), zone = stage.closest('.lt-hero');
    zone.addEventListener('mousemove', e => {
      const r = stage.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
      card.style.transform = `perspective(900px) rotateY(${x * 16}deg) rotateX(${-y * 16}deg)`;
    });
    zone.addEventListener('mouseleave', () => card.style.transform = '');
  }
  if (fine) $$('[data-magnet]').forEach(b => {
    b.addEventListener('mousemove', e => {
      const r = b.getBoundingClientRect();
      b.style.transform = `translate(${(e.clientX - r.left - r.width / 2) * 0.25}px,${(e.clientY - r.top - r.height / 2) * 0.35}px)`;
    });
    b.addEventListener('mouseleave', () => b.style.transform = '');
  });

  $$('[data-countdown]').forEach(el => {
    const parts = $$('span', el);
    const tick = () => {
      const now = new Date(), end = new Date(now); end.setHours(23, 59, 59, 999);
      const s = Math.max(0, Math.floor((end - now) / 1000));
      [Math.floor(s / 3600), Math.floor(s % 3600 / 60), s % 60].forEach((v, i) => parts[i] && (parts[i].textContent = String(v).padStart(2, '0')));
    };
    tick(); setInterval(tick, 1000);
  });
  const sio = new IntersectionObserver(es => es.forEach(e => {
    if (e.isIntersecting) { $('span', e.target).style.width = Math.min(100, e.target.dataset.level) + '%'; sio.unobserve(e.target); }
  }), { threshold: 0.6 });
  $$('[data-stockbar]').forEach(b => sio.observe(b));

  const counts = $$('[data-cart-count]'), cartBtn = $('.lt-header__cart'), pop = $('[data-cartpop]');
  let popTimer;
  const closeBtn = $('[data-cartpop-close]');
  if (closeBtn) closeBtn.addEventListener('click', () => pop.hidden = true);
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  $$('[data-buy]').forEach(box => {
    const main = $('[data-main-img]', box);
    const swap = src => { if (!main || !src) return; main.style.opacity = 0; setTimeout(() => { main.src = src; main.style.opacity = 1; }, 180); };
    $$('[data-thumb]', box).forEach(t => t.addEventListener('click', () => {
      $$('[data-thumb]', box).forEach(x => x.classList.remove('is-active'));
      t.classList.add('is-active'); swap(t.dataset.thumb);
    }));
    const idInput = $('[name="id"]', box), qty = $('[data-qty]', box);
    $$('[data-pack]', box).forEach(p => p.addEventListener('click', () => {
      $$('[data-pack]', box).forEach(x => x.classList.remove('is-active'));
      p.classList.add('is-active');
      idInput.value = p.dataset.variant;
      $$('[data-price]').forEach(el => el.textContent = p.dataset.priceFmt);
      $$('[data-compare]').forEach(el => el.textContent = p.dataset.compareFmt || '');
      swap(p.dataset.img);
      const r = p.getBoundingClientRect(); sparks(r.left + r.width / 2, r.top + 10);
    }));
    $$('[data-qty-btn]', box).forEach(b => b.addEventListener('click', () => {
      qty.value = clamp((parseInt(qty.value, 10) || 1) + parseInt(b.dataset.qtyBtn, 10), 1, 20);
    }));
    const form = $('form', box), atc = $('.lt-atc', box);
    if (!form || !atc) return;
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const label = $('[data-atc-label]', atc), old = label.textContent;
      atc.classList.add('is-loading'); label.textContent = 'Cargando…';
      try {
        const res = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(idInput.value, 10), quantity: parseInt(qty.value, 10) || 1 }] }) });
        if (!res.ok) throw new Error((await res.json()).description || 'Error');
        const cart = await (await fetch(root + 'cart.js')).json();
        counts.forEach(c => c.textContent = cart.item_count);
        if (cartBtn) { cartBtn.classList.remove('is-bump'); void cartBtn.offsetWidth; cartBtn.classList.add('is-bump'); }
        const r = atc.getBoundingClientRect();
        [0.2, 0.5, 0.8].forEach(k => sparks(r.left + r.width * k, r.top));
        popText(r.left + r.width / 2, r.top - 10, '¡LOCKED IN!');
        if (navigator.vibrate) try { navigator.vibrate([20, 40, 20]); } catch (err) {}
        addScore(250);
        if (pop) { pop.hidden = false; clearTimeout(popTimer); popTimer = setTimeout(() => pop.hidden = true, 7000); }
        label.textContent = '✓ Añadido'; setTimeout(() => label.textContent = old, 1800);
      } catch (err) {
        label.textContent = err.message || 'Error'; setTimeout(() => label.textContent = old, 2200);
      } finally { atc.classList.remove('is-loading'); }
    });
    const sticky = $('[data-sticky-atc]');
    if (sticky) {
      $('button', sticky).addEventListener('click', () => box.scrollIntoView({ behavior: 'smooth', block: 'start' }));
      new IntersectionObserver(([e]) => sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0)).observe(form);
    }
  });
})();